import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgClass } from '@angular/common';
//import { ProductDisplayDescComponent } from "../../../product-display-desc/product-display-desc.component";
import { ProductService } from '../../../../../_services/product.service';

@Component({
    selector: 'app-give-away-product-selection',
    imports: [NgClass],
    templateUrl: './give-away-product-selection.component.html',
    styleUrl: './give-away-product-selection.component.css'
})
export class GiveAwayProductSelectionComponent {
  readonly dialogRef = inject(MatDialogRef<GiveAwayProductSelectionComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);

  maxSelections: number = 1;
  selectedProducts: any[] = [];
  loading: boolean = false;

  constructor(private productService: ProductService) {
    this.maxSelections = this.data.maxSelections || 1;
  }
  isSelected(product: any): boolean {
    return this.selectedProducts.some(p => p.variantSku === product.variantSku);
  }

  toggleSelection(product: any) {
    if (this.isSelected(product)) {
      this.selectedProducts = this.selectedProducts.filter(p => p.variantSku !== product.variantSku);
    } else if (this.selectedProducts.length < this.maxSelections) {
      this.selectedProducts.push(product);
    }
  }

  async claimGifts() {
    if (this.selectedProducts.length !== this.maxSelections || this.loading) return;
    this.loading = true;
    const cartItems: any[] = [];
    for (const product of this.selectedProducts) {
      const item = await this.loadProductData(product);
      if (item) cartItems.push(item);
    }
    this.loading = false;
    this.dialogRef.close(cartItems);
  }

  closePopup() {
    this.dialogRef.close();
  }

  private loadProductData(product: any): Promise<any> {
    return new Promise((resolve) => {
      this.productService.getProductBySlug(product.productSlug).subscribe({
        next: (response) => {
          const filtredVariants = response.variants.filter((pv: any) => pv.sku === product.variantSku);
          if (filtredVariants && filtredVariants.length > 0) {
            const selectedVariant = filtredVariants[0];
             const attrValueId = selectedVariant.variantdetails?.[0]?.productAttributeValueId;
            let productFormat = '';
            if (attrValueId) {
              for (const attr of response.attributes) {
                const matched = attr.attributevalues?.find((av: any) => av.id === attrValueId);
                if (matched) {
                  productFormat = matched.productattributeName?.attributeValue || '';
                  break;
                }
              }
            }
            resolve({
              name: productFormat ? `${response.product.productName} - ${productFormat}` : response.product.productName,
              sku: product.variantSku,
              productId: response.product.productId,
              productSlug: response.product.productSlug,
              variantId: selectedVariant.productVariantId,
              unitPrice: '0.00',
              quantity: 1,
              onSale: selectedVariant.discPrice > 0 ? true : false,
              categorySlug:
                response.product.productcategories[0].category.categoryParentId == 0
                  ? response.product.productcategories[0].category.categorySlug
                  : response.product.productcategories[0].category.categoryParentIds.categorySlug,
              categoryId: response.product.productcategories[0].category.categoryId,
              parentId:
                response.product.productcategories[0].category.categoryParentId == 0
                  ? 0
                  : response.product.productcategories[0].category.categoryParentIds.categoryId,
              isFullCrate: response.product.productTemplateId == 1,
              weight: selectedVariant.weight,
              deliveryTermSlug: selectedVariant.deliveryterm?.deliveryTermSlug,
              image:
                selectedVariant.images && selectedVariant.images.length > 0
                  ? selectedVariant.images[0]
                  : 'https://placehold.co/600x600?text=' + response.product.productName,
              currentStock: selectedVariant.stockQty,
              productFormat: productFormat,
            });
          } else {
            resolve(null);
          }
        },
        error: (error) => {
          console.log(error);
          resolve(null);
        },
      });
    });
  }
}
